module.exports = {
  "thunderstorm": {
    "type": "ALARM",
    "title": "Thunderstorm",
    "name": "Thunderstorm Sounds",
    "description": null,
    "tier": 0,
    "variants": [],
    "alexa_alarm_url": "https://amzn.to/3tAGeOD"
  },
  "rain": {
    "type": "ALARM",
    "title": "Rain",
    "name": "Rain Sounds",
    "description": null,
    "tier": 0,
    "variants": [],
    "alexa_alarm_url": "https://amzn.to/3oSSRkw"
  },
  "ocean": {
    "type": "ALARM",
    "title": "Ocean",
    "name": "Ocean Sounds",
    "description": null,
    "tier": 0,
    "variants": [],
    "alexa_alarm_url": "https://amzn.to/3cRBvlQ"
  },
  "babblingbrook": {
    "type": "ALARM",
    "title": "Babbling Brook",
    "name": "Babbling Brook",
    "description": null,
    "tier": 0,
    "variants": [],
    "alexa_alarm_url": "https://amzn.to/36OMxo8"
  },
  "city": {
    "type": "ALARM",
    "title": "City",
    "name": "City Sounds",
    "description": null,
    "tier": 1,
    "variants": [],
    "alexa_alarm_url": "https://amzn.to/2NjGYaz"
  },
  "rainforest": {
    "type": "ALARM",
    "title": "Rainforest",
    "name": "Rainforest Sounds",
    "description": null,
    "tier": 0,
    "variants": [],
    "alexa_alarm_url": "https://amzn.to/3a2At4J"
  },
  "train": {
    "type": "ALARM",
    "title": "Train",
    "name": "Train Sounds",
    "description": null,
    "tier": 0,
    "variants": [],
    "alexa_alarm_url": "https://amzn.to/2NBZqek"
  },
  "cricket": {
    "type": "ALARM",
    "title": "Crickets",
    "name": "Cricket Sounds",
    "description": null,
    "tier": 0,
    "variants": [],
    "alexa_alarm_url": "https://amzn.to/37r4uJM"
  },
  "frog": {
    "type": "ALARM",
    "title": "Frogs",
    "name": "Frog Sounds",
    "description": null,
    "tier": 1,
    "variants": [],
    "alexa_alarm_url": "https://amzn.to/37tXrjr"
  },
  "bird": {
    "type": "ALARM",
    "title": "Bird",
    "name": "Bird Sounds",
    "description": null,
    "tier": 0,
    "variants": [],
    "alexa_alarm_url": "https://amzn.to/3tEEofQ"
  },
  "cat": {
    "type": "ALARM",
    "title": "Cat",
    "name": "Cat Sounds",
    "description": null,
    "tier": 1,
    "variants": [],
    "alexa_alarm_url": "https://amzn.to/3avhkIG"
  },
  "distantthunderstorm": {
    "type": "ALARM",
    "title": "Distant Thunderstorm",
    "name": "Distant Thunderstorm",
    "description": null,
    "tier": 1,
    "variants": [],
    "alexa_alarm_url": "https://amzn.to/3bFwScl"
  },
  "windchimes": {
    "type": "ALARM",
    "title": "Wind Chimes",
    "name": "Wind Chimes",
    "description": null,
    "tier": 0,
    "variants": [],
    "alexa_alarm_url": "https://amzn.to/37Rooh5"
  },
  "heavyrain": {
    "type": "ALARM",
    "title": "Heavy Rain",
    "name": "Heavy Rain Sounds",
    "description": null,
    "tier": 1,
    "variants": [],
    "alexa_alarm_url": "https://amzn.to/2ZSuCbY"
  },
  "forestnight": {
    "type": "ALARM",
    "title": "Forest Night",
    "name": "Forest Night",
    "description": null,
    "tier": 0,
    "variants": [],
    "alexa_alarm_url": "https://amzn.to/3e2KKjN"
  },
  "dream": {
    "type": "ALARM",
    "title": "Dream",
    "name": "Dream Sounds",
    "description": null,
    "tier": 0,
    "variants": [],
    "alexa_alarm_url": "https://amzn.to/3qYmB1h"
  },
  "owl": {
    "type": "ALARM",
    "title": "Owl",
    "name": "Owl Sounds",
    "description": null,
    "tier": 1,
    "variants": [],
    "alexa_alarm_url": "https://amzn.to/2ZsprzB"
  },
  "cicada": {
    "type": "ALARM",
    "title": "Cicadas",
    "name": "Cicada Sounds",
    "description": null,
    "tier": 1,
    "variants": [],
    "alexa_alarm_url": "https://amzn.to/2NJbR8o"
  },
  "lake": {
    "type": "ALARM",
    "title": "Lake",
    "name": "Lake Sounds",
    "description": null,
    "tier": 0,
    "variants": [],
    "alexa_alarm_url": "https://amzn.to/3qAyA4O"
  },
  "seagull": {
    "type": "ALARM",
    "title": "Seagulls",
    "name": "Seagull Sounds",
    "description": null,
    "tier": 0,
    "variants": [],
    "alexa_alarm_url": "https://amzn.to/2M2BIHI"
  },
  "spa": {
    "type": "ALARM",
    "title": "Spa",
    "name": "Spa Sounds",
    "description": null,
    "tier": 1,
    "variants": [],
    "alexa_alarm_url": "https://amzn.to/2ZAlQPH"
  },
  "snoring": {
    "type": "ALARM",
    "title": "Snoring",
    "name": "Snoring Sounds",
    "description": null,
    "tier": 1,
    "variants": [],
    "alexa_alarm_url": "https://amzn.to/3szqKZI"
  },
  "peaceful": {
    "type": "ALARM",
    "title": "Peaceful",
    "name": "Peaceful Sounds",
    "description": null,
    "tier": 1,
    "variants": [],
    "alexa_alarm_url": "https://amzn.to/2Nz6fgJ"
  },
  "piano": {
    "type": "ALARM",
    "title": "Piano",
    "name": "Piano Sounds",
    "description": null,
    "tier": 0,
    "variants": [],
    "alexa_alarm_url": "https://amzn.to/3uyzwsR"
  },
  "harp": {
    "type": "ALARM",
    "title": "Harp",
    "name": "Harp Sounds",
    "description": null,
    "tier": 1,
    "variants": [],
    "alexa_alarm_url": "https://amzn.to/37QJUmc"
  },
  "medieval": {
    "type": "ALARM",
    "title": "Medieval",
    "name": "Medieval Sounds",
    "description": null,
    "tier": 1,
    "variants": [],
    "alexa_alarm_url": "https://amzn.to/2O8lflO"
  },
  "guitar": {
    "type": "ALARM",
    "title": "Guitar",
    "name": "Guitar Sounds",
    "description": null,
    "tier": 1,
    "variants": [],
    "alexa_alarm_url": "https://amzn.to/2O5icuY"
  },
  "flute": {
    "type": "ALARM",
    "title": "Flute",
    "name": "Flute Sounds",
    "description": null,
    "tier": 1,
    "variants": [],
    "alexa_alarm_url": "https://amzn.to/2MwfyxS"
  },
  "ukulele": {
    "type": "ALARM",
    "title": "Ukulele",
    "name": "Ukulele Sounds",
    "description": null,
    "tier": 1,
    "variants": [],
    "alexa_alarm_url": "https://amzn.to/3dTXitt"
  },
  "farm": {
    "type": "ALARM",
    "title": "Farm",
    "name": "Farm Sounds",
    "description": null,
    "tier": 1,
    "variants": [],
    "alexa_alarm_url": "https://amzn.to/3qzZry0"
  }
};